import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import Panel from './Panel'

const NotesText = styled.pre`
  border: solid 5px #cfcfcf;
  border-width: 0 0 0 5px;
  border-radius: 0;
  padding-left: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
  font-family: sans-serif;
  white-space: pre-wrap;
  word-break: break-word;
  flex-grow: 1;
  background-color: #fff;
`

const Notes = () => {
  const note = useSelector(state => state.notes.text)

  return note.length > 0 ? (
    <div style={{ backgroundColor: '#f4f5f7', padding: '1.5%' }}>
      <Panel fullWidth>
        <div>
          <NotesText>{note}</NotesText>
        </div>
      </Panel>
    </div>
  ) : <></>
}

export default Notes
